import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import googleMaps from "./plugins/googleMaps";
import split from "./plugins/split";
import './registerServiceWorker';
import VueGtag from "vue-gtag";
import LogRocket from 'logrocket';
import mixpanel from "mixpanel-browser";

LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);

mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
  debug: true,
  track_pageview: true,
  persistence: "localStorage"
});

Vue.config.productionTip = false;
Vue.use(Argon);

// Google Analytics configuration
Vue.use(VueGtag, {
  config: { id: 'G-WTSD5ZE22R' }
}, router)

Vue.use(googleMaps, {
  apiKey: process.env.VUE_APP_MAPS_API_KEY
});

Vue.use(split, {
  authorizationKey: process.env.VUE_APP_SPLIT_API_KEY
})

Vue.config.ignoredElements = ['minnit-chat']

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
